export type WaveFreeLifecycle = {
  startedAt: number;
  expiresAt: number;
  firstWarningAt: number;
  finalWarningAt: number;
  firstWarningSentAt: number | null;
  finalWarningSentAt: number | null;
  state: 'ACTIVE' | 'CANCELLED' | 'EXPIRED' | 'CLEANUP_PENDING' | 'CLEANED';
  generation: number;
  expirationOutcome: 'DELETE_ACCOUNT' | 'DISABLE_WAVE';
};

export const isWaveRecoveryError = (error: any): boolean => {
  const e = error?.data?.code ? error.data : error;
  return (
    Number(e?.code) === 402 &&
    [
      'Wave free access has expired; sign in for account and billing recovery',
      'Account recovery session cannot authorize product operations'
    ].includes(e?.message)
  );
};
export const isWaveRestricted = (d?: WaveFreeLifecycle | null) =>
  !!d && ['EXPIRED', 'CLEANUP_PENDING', 'CLEANED'].includes(d.state);
export const isWaveCleanup = (d?: WaveFreeLifecycle | null) => !!d && ['CLEANUP_PENDING', 'CLEANED'].includes(d.state);
export const waveDeadline = (value: number) =>
  new Date(value)
    .toISOString()
    .replace('T', ' ')
    .slice(0, 19) + ' UTC';
export const warningSent = (value?: number | null) => typeof value === 'number' && value > 0;
export const isWaveAuthenticationPage = (path: string) => /^\/(?:(?:editor\/)?login|recovery)(?:[/?#]|$)/.test(path);
export const isRecoveryPage = (path: string) =>
  isWaveAuthenticationPage(path) ||
  /^\/(wave-access|account|subscription|pricing(?:\/upgrade)?)\/?$/.test(path.split('?')[0]);
export const forceWaveLogin = (product: string, query: { freshWave?: unknown }) =>
  product === 'WAVE' && query?.freshWave === '1';
